import EditSettingsForm from '../../../../../components/EditSettingsForm/EditSettingsForm'
import PipelineParameterFormFieldset from '../PipelineParameterFormFieldset/PipelineParameterFormFieldset'

import type {PipelineParameterFormProps} from './PipelineParameterForm.types'
import usePipelineParameterForm from './usePipelineParameterForm'

function PipelineParameterForm({
  value = '',
  name = '',
  onConfirm,
  onDelete,
}: PipelineParameterFormProps) {
  const {
    fieldName,
    fieldValue,
    isFormInvalid,
    keyPressInputFormHandler,
    confirmButtonClickHandler,
    changeFormFieldsetHandler,
    validFormFieldsetHandler,
  } = usePipelineParameterForm(name, value, onConfirm)

  return (
    <EditSettingsForm
      onConfirmClick={confirmButtonClickHandler}
      onDeleteClick={onDelete}
      disabled={isFormInvalid}
    >
      <PipelineParameterFormFieldset
        name={fieldName}
        value={fieldValue}
        onKeyPress={keyPressInputFormHandler}
        onChange={changeFormFieldsetHandler}
        onValid={validFormFieldsetHandler}
      />
    </EditSettingsForm>
  )
}

export default PipelineParameterForm
